import React from 'react'

// Styles
import './index.scss'

// Constants
import { NEWSLETTERS } from './constants'

const Newsletter = () => {
  return (
    <div className="newsletter-parent">
      <div className="page-banner bg-page-banner vh-center">
        <div className="banner-content">
          <h2>Newsletter</h2>
        </div>
      </div>

      {/* <div className="f-w content">
        <div className="container">
          <div className="flex xlg-col-flex">
            <div className="inner">
              <p>With wide-ranging expertise and experience, EIDIM offers a comprehensive audio visual service making us the AV partner of choice for many organisations. We can lead and manage large and complex audio visual projects, but also tailor effective solutions for smaller-scale requirements.</p>
            </div>
          </div>
        </div>
      </div> */}

      <div className="container newsletter-grid">
        <div className="page-section">
          <div className="flex xlg-col-flex flex-wrap">
            {
              NEWSLETTERS.reverse().map((item, i) => {
                return (
                  <div className="item c-padd" key={`newsletter-${item + i}`}>
                    <a href={item.pdf} target="_blank">
                      <div className="content c-padd">
                        <h4>{item.date}</h4>
                      </div>
                    </a>
                  </div>
                )
              })
            }
          </div>
        </div>
      </div>
    </div>
  )
}

export default Newsletter